export default __webpack_public_path__ + "static/media/new-patient-2.4d3bd30c.png";